import { Autocomplete, Input, MenuItem } from '@trackman/web-shared-components';
import { AutocompleteWrapper } from 'components/ui/AutocompleteWrapper/AutocompleteWrapper';
import { IconWrapper } from 'components/UmpireSearch/UmpireSearchStyles';
import { ServiceTypes } from 'constants/ServiceTypes';
import { ReactComponent as DropdownIcon } from 'images/dropdownIcon.svg';
import { ReactComponent as BadgeCloseIcon } from 'images/TopBar/badgeCloseIcon.svg';
import { ReactComponent as PlayerSelectedIcon } from 'images/TopBar/playerSelectedIcon.svg';
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { FilterPosition, FilterPositionDict, FilterStore } from 'stores/FilterStore';
import { Badge, CurrentFilters, PlayerItem } from './styles/FiltersStyles';

interface FilterSelectProps {
  position: FilterPosition;
  players: {
    label: string;
    value: string;
  }[];
}

export const FilterSelect: React.FC<FilterSelectProps> = observer((props) => {
  const filterStore = useInjection<FilterStore>(ServiceTypes.FilterStore);
  const { position, players } = props;

  const addPlayerToFilter = useCallback(
    (_: any, newPlayer: any) => {
      const player = players.find((p) => p.value === newPlayer.value);

      if (player) {
        filterStore.addPlayerToFilter(player, position);
      }
    },
    [players]
  );

  const filters = filterStore.filters.filter((f) => f.position === position);

  return (
    <AutocompleteWrapper>
      <Autocomplete
        data-testid={`filter-select-${position}`}
        width='100%'
        options={players}
        onChange={addPlayerToFilter}
        disableClearable
        value={''}
        popupIcon={
          <IconWrapper>
            <DropdownIcon />
          </IconWrapper>
        }
        renderInput={(params) => {
          return <Input data-testid={`filter-input-${position}`} {...params} label={FilterPositionDict[position]} />;
        }}
        renderOption={(params, option, state) => {
          return (
            <MenuItem data-testid={`filter-option-${state.index}`} {...params} key={option.value} value={option.value}>
              <PlayerItem>
                {option.label} <span>{filterStore.isPlayerInFilter(option.value, position) ? <PlayerSelectedIcon /> : ''}</span>
              </PlayerItem>
            </MenuItem>
          );
        }}
      />
      {filters.length > 0 && (
        <CurrentFilters>
          {filters.map((player, index) => {
            return (
              <Badge
                key={player.value}
                data-testid={`filter-badge-${index}`}
                onClick={() => filterStore.removePlayerFromFilter(player.value, position)}
              >
                <div>{player.label}</div> <BadgeCloseIcon />
              </Badge>
            );
          })}
        </CurrentFilters>
      )}
    </AutocompleteWrapper>
  );
});
